import { CoursePricingOption } from '../../../store/features/courseOptions/types';

export function getEnabledSiteOptionIndex(options: CoursePricingOption[]) {
  return options.find((option) => option.enabled)?.index;
}
